import { Theme } from '@mui/material';

/** styles */
export const securityColorMap = (theme: Theme, score) => {
  if (score < 3) {
    return theme.palette.success.main;
  }
  if (score < 5) {
    return theme.palette.info.main;
  }

  if (score < 7) {
    return theme.palette.warning.main;
  }
  if (score < 9) {
    return theme.palette.warning.main;
  }

  return theme.palette.error.main;
};
